import React from 'react'

export default function Refunded({notification}) {
  return (
    <div>
            <div className="container text-center bg-white">
          <div className="blueBanner mt-2">
            <p className=" fw-bold p-2">Customer Refunded</p>
        
          </div>
          <p>{notification.content}</p></div>
    </div>
  )
}
